interface PricingCellProps {
  price: string
}

export function PricingCell({ price }: PricingCellProps) {
  return (
    <div>
      <p className="text-[#1d1d1f] font-medium">
        <span className="text-sm text-[#86868b] block mb-1">Starting at</span>
        <span className="text-xl font-semibold">{price}</span>
        <span className="text-sm text-[#86868b] ml-1">user/month</span>
      </p>
      <p className="text-xs text-[#86868b] mt-1">billed annually</p>
    </div>
  )
}
